import { ReactElement } from 'react'

import { OnboardingStep } from '@views/onboarding/enums/onboardingStep'

import { AccountingManagementStep } from '../../AccountingManagementStep'
import { IntentTileSelectorStep } from '../../IntentTileSelectorStep'
import { InvoicesStep } from '../../InvoicesStep'
import { NamePhoneStep } from '../../NamePhoneStep'
import { WorkStyleStep } from '../../WorkStyleStep'

export const getStepComponentMapFromPath = (): Record<OnboardingStep, ReactElement> => ({
  [OnboardingStep.AccountingManagement]: <AccountingManagementStep />,
  [OnboardingStep.Intent]: <IntentTileSelectorStep />,
  [OnboardingStep.Invoices]: <InvoicesStep />,
  [OnboardingStep.NamePhone]: <NamePhoneStep />,
  [OnboardingStep.WorkStyle]: <WorkStyleStep />,
})
